import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SiTextField from "../../../core/si-textfield";
import { Box, Button, Grid, Typography } from "@mui/material";
import FormGenerator from "../../../core/form-generator";
import { INWARD_FORM1, INWARD_FORM2 } from "./helper";
import { formatDate, handleFormValidation } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import SiAutocomplete from "../../../core/si-autocomplete";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import ClearIcon from "@mui/icons-material/Clear";
import { DATE_FORMATS } from "../../../utils/constants";
import { Icon } from "@iconify/react";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import WorkOrderPdf from "./work-order-pdf";
import { STATE_LIST } from "../../../utils/state-list";
const FloatEngineInward = () => {
  const [ticketDetail, setTicketDetails] = useState({});
  const [staticFormData, setStaticFormData] = useState({});
  const [formData, setFormData] = useState({});
  const [selectedSearchEngine, setSelectedSearchEngine] = useState("");
  const [searchEngineOptions, setSearchEngineOptions] = useState([]);
  const [submittedWorkOrder, setSubmittedWorkOrder] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [errors, setErrors] = useState({});
  const workOrderRef = useRef(null);
  const navigate = useNavigate();
  let engineTimeout = null;

  const submitWorkOrder = () => {
    const isValid = handleFormValidation(INWARD_FORM2, setErrors, formData);
    if (isValid) {
      let payload = {
        ...formData,
        state: formData?.state?.value,
      };
      if (submittedWorkOrder) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.CREATE_WORK_ORDER}/${submittedWorkOrder}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Work Order Updated Successfully");
              setStaticFormData({});
              setFormData({});
              setSelectedSearchEngine("");
              setSubmittedWorkOrder(null);
              setErrors({});
            }
          })
          .catch((err) => console.error(err));
      } else {
        payload = {
          ...payload,
          fieldWarrantyEngineInward: selectedSearchEngine?.value,
          engineReplacementApprovedBy: staticFormData?.assignedApprover,
          natureOfCompllaint:
            staticFormData?.customerComplaintCode?.description,
          engineReplacementApprovalMode: staticFormData?.underWarranty,
          oem: staticFormData?.oem,
          inspectedBy: staticFormData?.inspectedBy,
          listNumber: staticFormData?.listNumber,
          hoursCovered: staticFormData?.hmr,
          fieldWarrantyEngineInvoiceNumber: staticFormData?.invoiceNumber,
          fieldWarrantyEngineInvoiceDate: moment(
            staticFormData?.invoiceDate,
            "DD/MM/YYYY",
            true
          ),

          oemOrg: staticFormData?.oemOrg,
        };
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.CREATE_WORK_ORDER}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Work Order Created Successfully");
              setStaticFormData({});
              setFormData({});
              setSelectedSearchEngine("");
              setSubmittedWorkOrder(null);
              setErrors({});
              // navigate(-1);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const loadEngines = async (inputValue) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.GET,
        `${HOSTNAME}${REST_URLS.SEARCH_ENGINE}`,
        null,
        { searchTerm: inputValue }
      );
      setSearchEngineOptions(
        response.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };

  const handleEngineSearch = (newInputValue) => {
    if (newInputValue) {
      clearTimeout(engineTimeout);
      engineTimeout = setTimeout(() => loadEngines(newInputValue), 300);
    }
  };
  const getTicketEngineDetails = (value) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.GET_TICKET_DETAILS_FROM_ENGINE}`,
      null,
      { engineSerialNumber: value }
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          if (res?.ticket) {
            setTicketDetails(res.ticket);

            setStaticFormData({
              ...res.ticket,
              assignedApprover: res.ticket?.assignedApprover?.name,
              underWarranty: res.ticket?.underWarranty
                ? "In Warranty"
                : "Out of Warranty",
              listNumber: res?.ticket?.listNumber,
              inspectedBy: res.ticket?.serviceEngineer?.name,
              oem: res?.ticket?.oemOrg?.name,
              oemOrg: res?.ticket?.oemOrg?.id,
              detailsOfObservation:
                res?.ticket?.jointInspectionReport?.detailsOfObservation,
              engineReplacementApprovedDate:
                (res?.ticket.engineReplacementApprovedDate &&
                  moment(res?.ticket.engineReplacementApprovedDate).format(
                    "DD/MM/YYYY"
                  )) ||
                "",

              invoiceDate:
                (res?.ticket?.invoiceDate &&
                  moment(res.ticket?.invoiceDate).format("DD/MM/YYYY")) ||
                "",
              invoiceNumber: res?.ticket?.invoiceNumber,
              natureOfComplaint:
                res?.ticket?.customerComplaintCode?.description,
            });
            if (res.workorder) {
              const { workorder } = res;
              setFormData((prevVal) => ({
                ...prevVal,
                fieldWarrantyEngineInwardDate:
                  workorder.fieldWarrantyEngineInwardDate,
                complaintEngineDispatchDate:
                  workorder?.complaintEngineDispatchDate,
                transporter: workorder.transporter,
                docketNumber: workorder.docketNumber,
                engineReceivedLocation: workorder.engineReceivedLocation,
                dealersName: workorder.dealersName,
                fipNo: workorder.fipNo,
                fieldWarrantyReferenceNumber:
                  workorder.fieldWarrantyReferenceNumber,
                missingItems: workorder.missingItems,
                damagedItem: workorder.damagedItem,
                jointInspection: workorder.jointInspection,
                enclosure: workorder.enclosure,
                seFindings: workorder.seFindings,
                complaintReferenceNumber: workorder.complaintReferenceNumber,
                state: STATE_LIST?.find(
                  (state) => state?.value === workorder?.state
                ),
              }));
              setSubmittedWorkOrder(workorder.id);
            }
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const searchHandler = () => {
    const { value } = selectedSearchEngine;
    getTicketEngineDetails(value);
  };

  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.CREATE_WORK_ORDER}`,
      null,
      { download: true },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Float Engine Inward.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };
  
  const handleGeneratePdf = async () => {
    const input = workOrderRef.current;

    try {
      const canvas = await html2canvas(input, {
        scale: 2, // Increase scale for better quality
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;
      let heightLeft = imgHeight;
      let position = 0;

      while (heightLeft > 0) {
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
        position -= pdfHeight;

        if (heightLeft > 0) {
          pdf.addPage(); // Add a new page if content overflows
        }
      }

      pdf.save("document.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setTimeout(() => {
        setIsDownloading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (isDownloading) {
      handleGeneratePdf();
    }
  }, [isDownloading]);

  return (
    <div className="page-body">
      {/* <div className=" view-detailed-ticket"> */}
      {/* <ArrowBackIcon
          sx={{ cursor: "pointer", marginRight: "20px" }}
          onClick={() => {
            navigate(-1);
          }}
        /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <p className="tab-name">Float Engine Movements</p>
          <p className="section-name">Float Engine Inward</p>
        </div>
        <Box sx={{ display: "flex", gap: "16px", alignItems: "center", mr: 6 }}>
          <CustomButtonComponent
            variant="contained"
            color="success"
            onClick={downloadReports}
          >
            Download All
          </CustomButtonComponent>
          {submittedWorkOrder &&
            (isDownloading ? (
              <Typography>Downloading...</Typography>
            ) : (
              <CustomButtonComponent
                variant="contained"
                color="success"
                startIcon={
                  <Icon
                    icon="solar:download-bold-duotone"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ color: "white" }}
                  />
                }
                onClick={() => {
                  setIsDownloading(true);
                  handleGeneratePdf();
                }}
              >
                Download
              </CustomButtonComponent>
            ))}
        </Box>
      </Box>
      {/* </div> */}
      <div className="form-con mt-0">
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Grid item md={3}>
            <p style={{ marginTop: "0px" }}>Field Warranty Engine - Inward</p>
            <SiAutocomplete
              value={selectedSearchEngine}
              onChange={setSelectedSearchEngine}
              options={searchEngineOptions}
              placeholder="Field Warranty Engine"
              onInputChange={(newInputValue) =>
                handleEngineSearch(newInputValue)
              }
              clearIcon={
                <ClearIcon
                  fontSize="small"
                  onClick={() => {
                    setStaticFormData({});
                    setFormData({});
                  }}
                />
              }
            />
          </Grid>
          <Grid item md={6.5} xs={1}></Grid>
          <Grid item md={2}>
            <CustomButtonComponent
              variant="contained"
              fullWidth
              startIcon={<SearchTwoToneIcon />}
              color="success"
              disabled={!selectedSearchEngine}
              onClick={searchHandler}
            >
              Search
            </CustomButtonComponent>
          </Grid>
        </Grid>
      </div>
      <div className="form-con">
        <FormGenerator
          errors={errors}
          setErrors={setErrors}
          config={INWARD_FORM1}
          formData={staticFormData}
          setFormData={setStaticFormData}
        />
      </div>
      <div className="form-con">
        <FormGenerator
          errors={errors}
          setErrors={setErrors}
          config={INWARD_FORM2}
          formData={formData}
          setFormData={setFormData}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
          <CustomButtonComponent
            variant="contained"
            sx={{ width: { md: "20%", xs: "100%" } }}
            onClick={submitWorkOrder}
            disabled={!selectedSearchEngine}
          >
            Create Work Order
          </CustomButtonComponent>
        </Box>
      </div>
      {isDownloading && (
        <div ref={workOrderRef}>
          <WorkOrderPdf data={{ ...formData, ...staticFormData }} />
        </div>
      )}
    </div>
  );
};

export default FloatEngineInward;
